import React, { useEffect, useRef } from 'react';
import ChatHistorySidebar from '../ChatHistorySidebar';
import '../ChatWindow.css';
import './chat.css';

/**
 * ChatShell: shared layout wrapper for all chat-like pages
 * - Renders a standard sidebar with history (optional)
 * - Provides a main chat area where callers render messages/input
 * - Keeps CSS/classes consistent with the primary ChatWindow
 */
export function ChatShell({
  historyProps, // { history, onChatSelect, activeChatId, onNewChat, refreshHistory, newChatButtonTitle }
  children,     // main chat content (messages area + input bar)
  rightPanel,   // optional fixed right-side panel (e.g., cheatsheet)
  isBusy = false,
  onBackendBusyChange,
}) {
  const lastBusyRef = useRef(null);

  useEffect(() => {
    if (typeof onBackendBusyChange !== 'function') return;
    const busy = Boolean(isBusy);
    if (lastBusyRef.current !== busy) {
      lastBusyRef.current = busy;
      onBackendBusyChange(busy);
    }
  }, [isBusy, onBackendBusyChange]);

  useEffect(() => {
    // Ensure we don't leave the app stuck in a "busy" state if the page unmounts.
    return () => {
      if (typeof onBackendBusyChange === 'function') {
        onBackendBusyChange(false);
      }
    };
  }, [onBackendBusyChange]);

  const hasSidebar = !!historyProps;
  const newChatTitle = typeof historyProps?.newChatButtonTitle === 'function'
    ? historyProps.newChatButtonTitle()
    : '+ New Chat';

  return (
    <div className="chat-window-container">
      {hasSidebar && (
        <div className="chat-sidebar-wrapper">
          <ChatHistorySidebar
            history={historyProps.history}
            onChatSelect={historyProps.onChatSelect}
            activeChatId={historyProps.activeChatId}
            refreshHistory={historyProps.refreshHistory}
          />
          <button
            onClick={historyProps.onNewChat}
            className="new-chat-button"
            disabled={historyProps.disabled}
            title={newChatTitle}
          >
            {newChatTitle}
          </button>
        </div>
      )}

      <div className="chat-main-area">
        <div className="chat-area">
          {children}
        </div>
      </div>

      {rightPanel}
    </div>
  );
}

export default ChatShell;
